import createClient, { type Middleware } from 'openapi-fetch';
import type { paths } from './generated/schema.ts';

export type { paths, components } from './generated/schema.ts';

export interface ApiClientOptions {
  baseUrl: string;
  /** Returns the current access token; called on every request. */
  getToken?: () => string | undefined | Promise<string | undefined>;
  fetch?: typeof fetch;
}

/** The only way the web app, the assistant and the fleet call the API. Generated from its OpenAPI document. */
export function createApiClient({ baseUrl, getToken, fetch: f }: ApiClientOptions) {
  const client = createClient<paths>({ baseUrl, ...(f ? { fetch: f } : {}) });
  if (getToken) {
    const auth: Middleware = {
      async onRequest({ request }) {
        const token = await getToken();
        if (token) request.headers.set('authorization', `Bearer ${token}`);
        return request;
      },
    };
    client.use(auth);
  }
  return client;
}

export type ApiClient = ReturnType<typeof createApiClient>;
